import moment from 'dayjs';
import React, { createContext, useContext, useState,useEffect } from 'react';
import useAuth from 'hooks/useAuth'
import 'dayjs/locale/th'; 
moment.locale('th')
moment.extend(require('dayjs/plugin/buddhistEra'))
moment.extend(require('dayjs/plugin/localizedFormat'))
const TimeFormatContext = createContext();

export const TimeFormatProvider = ({ children }) => {
  const {config} = useAuth()
  const [timeFormat, setTimeFormat] = useState('HH:mm'); // Default time format
  const [dateFormat, setDateFormat] = useState('DD/MM/YYYY'); // Default time format
  const [dateFullFormat, setDateFullFormat] = useState('dddd, DD/MM/YYYY'); // Default time format

  useEffect(()=>{
    let find = config.find(({configCode})=>configCode==='user_date_format') || null        
    if(find){
      changeDateFormat(find.data)
    }
    find = config.find(({configCode})=>configCode==='user_date_full_format') || null        
    if(find){
      changeDateFullFormat(find.data)
    }
    find = config.find(({configCode})=>configCode==='user_time_format') || null      
    if(find){
      changeTimeFormat(find.data)
    }
  },[config])

  const changeDateFormat = (format) => {
    //console.log('changeDate',format)
    setDateFormat(format);
  };

  const changeDateFullFormat = (format) => {
    //console.log('changeDate',format)
    setDateFullFormat(format);
  };

  const changeTimeFormat = (format) => {
    //console.log('changeTime',format)
    setTimeFormat(format);
  };
  const formatDate = (date,format=dateFormat) => {
    return formatDateTime(date,format)
  }
  const formatDateFull = (date,format=dateFullFormat) => {
    return formatDateTime(date,format)
  }

    const formatDateTimeFull = (date,format=`${dateFullFormat} ${timeFormat}`) => {
    return formatDateTime(date,format)
  }


  const formatTime = (date,format=timeFormat) => {
    return formatDateTime(date,format)
  }
  const formatDateTime = (date, format = `${dateFormat} ${timeFormat}`) => {
    //console.log('format',date,format)
    if(!date){
      return ""
    }
    let jsDate;
    // Check if the date is a Moment.js object
    if (date._isAMomentObject) {
      jsDate = date.toDate(); // Convert to JavaScript Date object
    }else if (date && typeof date.toDate === 'function') {
        // It's likely a Day.js object
      jsDate = date.toDate(); // Convert to JavaScript Date object            
    } else if (date instanceof Date) {
      jsDate = date; // It's already a JavaScript Date object
    } else if (typeof date === 'string') {
      // Attempt to parse the string with Moment.js
      let parsedDate = moment(date);
      if (parsedDate.isValid()) {
        jsDate = parsedDate.toDate();
      }else{
        parsedDate = moment(date, 'YYYY-MM-DD HH:mm:ss', true);
        if (parsedDate.isValid()) {
          jsDate = parsedDate.toDate();
        } else {
          console.error('Invalid date string');
          return '!'+date;
        }     
      } 
    } else {
      // Handle invalid date object or implement further checks as needed
      console.error('Invalid date object');
      return '!!'+date;
    }

    const buddhistYearOffset = 543;
    const buddhistYear = jsDate.getFullYear() + buddhistYearOffset;
    
    const momentResult = moment(jsDate).format(format)

    let formattedDate = momentResult
    //.replace('BBBB', buddhistYear.toString())
    //.replace('BB', buddhistYear.toString())
    //.replace('A', jsDate.getHours() >= 12 ? 'PM' : 'AM')

    return formattedDate;
  };

  return (
    <TimeFormatContext.Provider value={{ timeFormat,dateFormat,dateFullFormat,changeDateFormat, changeTimeFormat,changeDateFullFormat,formatDate,formatDateFull,formatTime,formatDateTime }}>
      {children}
    </TimeFormatContext.Provider>
  );
};

export const useTimeFormat = () => useContext(TimeFormatContext);
